// import
import Dashboard from "./pages/Dashboard/Dashboard";
// import Tables from "./pages/Dashboard/Tables";
import Billing from "./pages/Dashboard/Billing";
import RTLPage from "./pages/Dashboard/RTL";
import Profile from "./pages/Dashboard/Profile";
import SignIn from "./pages/Auth/AuthPage";
import SignUp from "./pages/Auth/components/SignUp";
import UserAccount from "./pages/UserAccount/index";
import Reservation from "pages/Reservation";
import {
  HomeIcon,
  StatsIcon,
  CreditIcon,
  PersonIcon,
  DocumentIcon,
  RocketIcon,
  SupportIcon,
} from "common/components/Icons/Icons";

const adminRoutes = [
  {
    path: "/dashboard",
    name: "داشبورد",
    icon: <HomeIcon color="inherit" />,
    component: Dashboard,
    layout: "/admin",
  },
  {
    path: "/tables",
    name: "جدول ها",
    icon: <StatsIcon color="inherit" />,
    component: UserAccount,
    layout: "/admin",
  },
  {
    path: "/billing",
    name: "مالی",
    icon: <CreditIcon color="inherit" />,
    component: Billing,
    layout: "/admin",
  },
  {
    path: "/rtl-support-page",
    name: "راستچین",
    rtlName: "آرتيإل",
    icon: <SupportIcon color="inherit" />,
    component: RTLPage,
    layout: "/admin",
  },
  {
    path: "/profile",
    name: "کاربر",
    icon: <PersonIcon color="inherit" />,

    component: Profile,
    layout: "/user",
  },
  {
    path: "/signin",
    name: " ورود",
    icon: <DocumentIcon color="inherit" />,
    component: <SignIn />,
    layout: "/auth",
  },
];

export const userRoutes = [
  // {
  //   path: "/dashboard",
  //   name: "داشبورد",
  //   icon: <HomeIcon color="inherit" />,
  //   component: <Dashboard />,
  //   // component: <div>hhhhhhhhhh/</div>,
  //   layout: "/user",
  // },
  {
    path: "/info",
    name: "حساب کاربری",
    icon: <PersonIcon color="inherit" />,
    component: <UserAccount />,
    layout: "/user",
  },
  {
    path: "/reservation",
    name: "نوبت‌های من",
    icon: <CreditIcon color="inherit" />,
    component: <Reservation />,
    layout: "/user",
  },
  // {
  //   path: "/rtl-support-page",
  //   name: " کاربر راستچین",
  //   icon: <SupportIcon color="inherit" />,
  //   component: <RTLPage />,
  //   layout: "/rtl",
  // },
  // {
  //   path: "/profile",
  //   name: "ادمین",
  //   icon: <StatsIcon color="inherit" />,

  //   component: <Profile />,
  //   layout: "/admin",
  // },
  // {
  //   path: "/signin",
  //   name: " کاربر ورود",
  //   icon: <DocumentIcon color="inherit" />,
  //   component: <SignIn />,
  //   layout: "/auth",
  // },
  // {
  //   path: "/signup",
  //   name: " کاربر ثبت نام",
  //   icon: <RocketIcon color="inherit" />,

  //   component: <SignUp />,
  //   layout: "/auth",
  // },
];
export default adminRoutes;
// {
//   name: "ACCOUNT PAGES",
//   category: "account",
//   rtlName: "صفحات",
//   state: "pageCollapse",
//   views: [
//     {
//       path: "/profile",
//       name: "Profile",
//       rtlName: "لوحة القيادة",
//       icon: <PersonIcon color="inherit" />,
//       secondaryNavbar: true,
//       component: Profile,
//       layout: "/admin",
//     },
//     {
//       path: "/signin",
//       name: "Sign In",
//       rtlName: "لوحة القيادة",
//       icon: <DocumentIcon color="inherit" />,
//       component: SignIn,
//       layout: "/auth",
//     },
//     {
//       path: "/signup",
//       name: "Sign Up",
//       rtlName: "لوحة القيادة",
//       icon: <RocketIcon color="inherit" />,
//       secondaryNavbar: true,
//       component: SignUp,
//       layout: "/auth",
//     },
//   ],
// },
